// Styles
import './sort.scss';

// Libs
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Blocks
import Products from '@/ebat/components/abstract/Products/Products';
// Constants
import { TAG_MANAGER } from '@/ebat/constants';
import SortOptions from '@/ebat/constants/sort';

// PropTypes
import {
  ConfigProductsDefaultProps,
  ConfigProductsPropTypes,
} from './ConfigProducts.proptypes';

const ConfigProducts = ({ className, configurations, sortables, source }) => {
  const { t } = useTranslation();

  const classNames = useMemo(
    () => ['config-products', className].filter((val) => val).join(' '),
    [className],
  );

  const { PRODUCTS_TABLE } = SortOptions();

  return (
    <div
      className={classNames}
      id="config-products-list"
      data-qa-id="config-products-list"
    >
      <div className="wrapper">
        <h2 className="h2">{t('ebat:entities:product.config.title')}</h2>
        <Products
          addToCartOptions={{
            dataLayer: {
              origin: TAG_MANAGER.ORIGINS.CONFIG_PRODUCTS,
            },
          }}
          localOptions={PRODUCTS_TABLE}
          productType="table"
          products={configurations}
          sortables={sortables}
          source={source}
        />
      </div>
    </div>
  );
};

ConfigProducts.defaultProps = {
  ...ConfigProductsDefaultProps,
};

ConfigProducts.propTypes = {
  ...ConfigProductsPropTypes,
};

export default ConfigProducts;
